import React, {useRef, useState} from "react";
import { Fade } from "react-reveal";
import "../ChatMessages.css";
import "./LiveConversationForm.css";
import PointOfContactDropdown from "./PointOfContactDropdown/PointOfContactDropdown";
import SendArrow from "../../../../Icons/SendArrow";
import Ajax from "../../../../Models/Ajax";

let connection = null;

const LiveConversationForm = ({config, live_conversation_config}) => {
  const minNameFieldHeight = 35;
  const maxNameFieldHeight = 170;
  const minMessageFieldHeight = 35;
  const maxMessageFieldHeight = 510;

  const [selectedPoc, setSelectedPoc] = useState(null);
  const [defaultPoc, setDefaultPoc] = useState(null);
  const [locations, setLocations] = useState([]);
  const [respondantName, setRespondantName] = useState("");
  const [respondantMessage, setRespondantMessage] = useState("");
  const [textareaHeightName, setTextareaHeightName] = useState(minNameFieldHeight);
  const [textareaHeightMessage, setTextareaHeightMessage] = useState(minMessageFieldHeight);
  const [respondantPhoneNumber, setRespondantPhoneNumber] = useState("");
  const [errorMessage, setErrorMessage] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [labels, setLabels] = useState({});

  const submitButton = useRef();
  const fadeDuration = 300;

  React.useEffect(() => {
    if(connection === null) {
      connection = new Ajax(config);
    }
  }, []);

  React.useEffect(() => {
    if(Object.keys(live_conversation_config).length !== 0) {
      setLabels(live_conversation_config.configured_labels);
      setLocations(live_conversation_config.locations);

      const locationOverride = config.tag?.location_override;

      if (locationOverride !== undefined) {
        setDefaultPoc(live_conversation_config.locations.find(location => location.value === ("" + locationOverride)));
      }
    }
  }, [live_conversation_config]);

  const onSubmit = async() => {
    if(submitButton.current.disabled) {
      return;
    }

    setErrorMessage(null);

    if(!selectedPoc) {
      setErrorMessage(labels.missingLocationLabel);
    } else if(!respondantPhoneNumber) {
      setErrorMessage(labels.missingPhoneNumberLabel);
    } else if(!respondantMessage) {
      setErrorMessage(labels.missingMessageLabel);
    } else {
      const result = await connection.initiateLiveConversation(selectedPoc, respondantName, respondantPhoneNumber, respondantMessage, labels.confirmationLabel);

      if(result.status === "success") {
        setIsSubmitted(true);
        submitButton.current.disabled = true;
        submitButton.current.classList.add("chat-send-initiation-form-button-disabled");
        submitButton.current.classList.remove("chat-send-initiation-form-button-hover");
      } else {
        if(result.error_code === "phone_number_error") {
          setErrorMessage(labels.wrongPhoneNumberLabel);
        } else {
          setErrorMessage(labels.submitErrorLabel);
        }
      }
    }
  };

  const onTextChange = (e, reply_value, setter, minHeight, maxHeight) => {
    const el = e.target;
    if (reply_value == "") {
      setter(minHeight);
    } else {
      setter(el.scrollHeight > maxHeight ? maxHeight : el.scrollHeight);
    }
  };

  const onTextChangeName = (e) => {
    onTextChange(e, respondantName, setTextareaHeightName, minNameFieldHeight, maxNameFieldHeight);
  };

  const onTextChangeMessage = (e) => {
    onTextChange(e, respondantMessage, setTextareaHeightMessage, minMessageFieldHeight, maxMessageFieldHeight);
  };

  return (
    <div className={"chat-text-container chat-form-text-container"}>
      <div className="chat-text">
        {labels &&
          <>
            <Fade bottom duration={fadeDuration}>
              <div className="chat-message-left-container">
                <div className="chat-message-left">{labels.greetingLabel}</div>
              </div>
            </Fade>

            <Fade bottom duration={fadeDuration}>
              <div className="chat-message-form">
                <div className="chat-form-label">
                  <span>
                    {labels.locationLabel}
                    <div className="chat-form-required-field">*</div>
                  </span>
                </div>
                <div className="chat-form-element">
                  <PointOfContactDropdown
                    allPointOfContacts={locations}
                    setPointOfContactValue={setSelectedPoc}
                    locationPlaceholder={labels.locationPlaceholderLabel}
                    noLocationLabel={labels.noLocationLabel}
                    preselectedLocation={defaultPoc}
                  />
                </div>


                <div className="chat-form-label">
                  {labels.nameLabel}
                </div>
                <textarea className="chat-form-element chat-form-textarea chat-form-name"
                  placeholder={labels.namePlaceholderLabel}
                  name={"respondantName"}
                  onKeyDown={e => onTextChangeName(e)}
                  style={{height: `${textareaHeightName}px`}}
                  onChange={e => setRespondantName(e.target.value)}
                  value={respondantName}
                />

                <div className="chat-form-label">
                  <span>
                    {labels.phoneNumberLabel}
                    <div className="chat-form-required-field">*</div>
                  </span>
                </div>
                <input
                  name="respondantPhoneNumber"
                  type="tel"
                  className="chat-form-element chat-form-phone-input"
                  placeholder={labels.phoneNumberPlaceholder}
                  value={respondantPhoneNumber}
                  onChange={(e) => setRespondantPhoneNumber(e.target.value)}
                />


                <div className="chat-form-label">
                  <span>
                    {labels.messageLabel}
                    <div className="chat-form-required-field">*</div>
                  </span>
                </div>
                <textarea className="chat-form-element chat-form-textarea chat-form-message"
                  placeholder={labels.messagePlaceholderLabel}
                  name={"respondantMessage"}
                  onKeyDown={e => onTextChangeMessage(e)}
                  style={{ height: `${textareaHeightMessage}px` }}
                  onChange={(e) => setRespondantMessage(e.target.value)}
                  value={respondantMessage}
                />

                {errorMessage !== null &&
                  <div className="chat-form-error-message chat-form-element">
                    {errorMessage}
                  </div>
                }

                <button className="chat-send-initiation-form-button chat-send-initiation-form-button-hover" onClick={() => onSubmit()} ref={submitButton}>
                  <div className="chat-send-initiation-form-button-label">
                    {labels.submitButtonLabel}
                    <SendArrow className={"chat-initiation-form-send-arrow"}/>
                  </div>
                </button>
              </div>
            </Fade>

            {isSubmitted &&
              <Fade bottom duration={fadeDuration}>
                <div className="chat-message-left-container">
                  <div className="chat-message-left">{labels.submittedMessageLabel}</div>
                </div>
              </Fade>
            }

            <div className="chat-form-disclaimer-message">
              {labels.disclaimerLabel}
            </div>
          </>
        }
      </div>
    </div>
  );
};

export default LiveConversationForm;
